<template>
  <div v-if="sessions.length > 0" class="mb-4 flex flex-col gap-2">
    <div
      v-for="s in sessions"
      :key="s.containerId"
      class="flex flex-wrap items-center justify-between gap-3 rounded-lg bg-orange-2 px-4 py-3 text-white shadow"
    >
      <div class="flex items-center gap-2">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span class="font-medium">
          Du arbetar som support på <strong>{{ s.containerName }}</strong>
          <template v-if="s.expiresAt">
            (till {{ formatExpiry(s.expiresAt) }})</template
          >
        </span>
      </div>
      <button
        class="rounded-md bg-white/20 px-3 py-1.5 text-sm font-medium hover:bg-white/30 disabled:opacity-50"
        :disabled="revokingId === s.containerId"
        @click="onRevoke(s.containerId)"
      >
        {{ revokingId === s.containerId ? "Avslutar..." : "Avsluta access" }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useOdinAccess } from "@/composables/useOdinAccess";

// Shows a persistent banner on every admin view while the current Odin user
// holds temporary support access on one or more containers. ANSKNI-54.
const router = useRouter();
const { sessions, refresh, revoke } = useOdinAccess();
const revokingId = ref<number | null>(null);

onMounted(() => {
  refresh();
});

const onRevoke = async (containerId: number) => {
  revokingId.value = containerId;
  try {
    const switchedAway = await revoke(containerId);
    // If we were working inside the container we just left, get out of it.
    if (switchedAway) router.push("/admin/odin/customers");
  } finally {
    revokingId.value = null;
  }
};

const formatExpiry = (iso: string): string => {
  const d = new Date(iso);
  return d.toLocaleString("sv-SE", { dateStyle: "short", timeStyle: "short" });
};
</script>
